export function Slider({ label, value, min, max, step = 0.01, onChange }: {
  label: string; value: number; min: number; max: number; step?: number; onChange: (v: number) => void;
}) {
  return (
    <label className="block">
      <div className="mb-1 flex items-baseline justify-between text-sm">
        <span>{label}</span>
        <span className="font-mono">{value}</span>
      </div>
      <input type="range" min={min} max={max} step={step} value={value} onChange={(e) => onChange(Number(e.target.value))} className="w-full" />
    </label>
  );
}

export function Toggle({ label, value, onChange }: { label: string; value: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm">
      <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} />
      <span>{label}</span>
    </label>
  );
}

export function Select<T extends string>({ label, value, options, onChange }: {
  label: string; value: T; options: [T, string][]; onChange: (v: T) => void;
}) {
  return (
    <label className="block text-sm">
      <span className="mb-1 block">{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value as T)} className="w-full rounded border border-[var(--border)] bg-[var(--entry)] px-2 py-1">
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  );
}

export function Pills<T extends string>({ label, value, options, onChange }: {
  label: string; value: T; options: [T, string][]; onChange: (v: T) => void;
}) {
  return (
    <div>
      <div className="mb-1 text-sm">{label}</div>
      <div className="flex flex-wrap gap-1">
        {options.map(([v, l]) => (
          <button key={v} onClick={() => onChange(v)}
            className={`rounded-sm px-2 py-1 text-sm transition ${value === v ? 'bg-[var(--content)] font-medium text-[var(--content-fg)]' : 'border border-[var(--border)] hover:bg-[var(--tertiary)]'}`}>
            {l}
          </button>
        ))}
      </div>
    </div>
  );
}

export function NumberPair({ label, w, h, lock, onW, onH, onLock }: {
  label: string; w: number | null; h: number | null; lock: boolean;
  onW: (v: number | null) => void; onH: (v: number | null) => void; onLock: (v: boolean) => void;
}) {
  return (
    <div>
      <div className="mb-1 text-sm">{label}</div>
      <div className="flex items-center gap-2">
        <input type="number" placeholder="W" value={w ?? ''} onChange={(e) => onW(e.target.value === '' ? null : Number(e.target.value))} className="w-20 rounded border border-[var(--border)] bg-[var(--entry)] px-2 py-1 text-sm" />
        <span>×</span>
        <input type="number" placeholder="H" value={h ?? ''} onChange={(e) => onH(e.target.value === '' ? null : Number(e.target.value))} className="w-20 rounded border border-[var(--border)] bg-[var(--entry)] px-2 py-1 text-sm" />
        <label className="ml-2 flex items-center gap-1 text-xs">
          <input type="checkbox" checked={lock} onChange={(e) => onLock(e.target.checked)} /> lock
        </label>
      </div>
    </div>
  );
}
